/**
 * 场次状态徽章组件
 */

import React from 'react';
import { Badge } from './ui/badge';
import { Circle, Clock, CheckCircle } from 'lucide-react';

interface SessionStatusBadgeProps {
  status: 'scheduled' | 'live' | 'ended';
  className?: string;
}

export const SessionStatusBadge: React.FC<SessionStatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'scheduled':
        return {
          label: '已预定',
          icon: <Clock className="h-3 w-3" />,
          variant: 'secondary' as const,
          className: 'border-[var(--status-action-border)] bg-transparent text-[var(--status-action)]',
        };
      case 'live':
        return {
          label: '直播中',
          icon: <Circle className="h-3 w-3 fill-current animate-pulse" />,
          variant: 'default' as const,
          className: 'border-transparent bg-[var(--status-live)] text-white',
        };
      case 'ended':
        return {
          label: '已结束',
          icon: <CheckCircle className="h-3 w-3" />,
          variant: 'outline' as const,
          className: 'border-[var(--border-control)] bg-transparent text-[var(--status-unknown)]',
        };
      default:
        return {
          label: '未知',
          icon: null,
          variant: 'outline' as const,
          className: '',
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Badge role="status" variant={config.variant} className={`flex items-center gap-1 ${config.className} ${className}`}>
      {config.icon}
      <span>{config.label}</span>
    </Badge>
  );
};
